import ControllerContainer from "../../components/Layout/ControllerContainer";
import { View } from "react-native";
import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import Image from "../../components/Image/Image";
import { Props } from "./models";
import {
	StyledButtonContainer,
	StyledController,
	StyledControllerButton,
	StyledControllerText,
	StyledControllerTextContainer,
	StyledText,
} from "./styled";

const Controller = (props: Props) => {
	return (
		<View>
			{/* @ts-ignore */}
			<ControllerContainer>
				{/* @ts-ignore */}
				<StyledController isTitle={props.isTitle} isShortClips={props.isShortClips}>
					{!props.isTitle ? (
						<>
							{!props.isNotRedeem ? (
								/* @ts-ignore */
								<StyledControllerButton>
									<TouchableButton
										componentTheme={ComponentThemeType.VinFast}
										type={ComponentTypeEnum.Secondary}
										onPress={props?.onPress}
									>
										{props?.data?.icon ? (
											// @ts-ignores
											<StyledButtonContainer>
												<Image source={{ uri: props?.data?.icon }} width={56} height={56}></Image>
												{/* @ts-ignores */}
												<StyledText>{props?.data?.buttonText}</StyledText>
											</StyledButtonContainer>
										) : (
											<></>
										)}
										{!props?.data?.icon && props?.data?.buttonText}
									</TouchableButton>
								</StyledControllerButton>
							) : (
								<></>
							)}
							{/* @ts-ignores */}
							<StyledControllerText>
								{/* @ts-ignores */}
								<StyledText>{props?.data?.textDescription}</StyledText>
							</StyledControllerText>
						</>
					) : (
						<></>
					)}
					{props.isTitle ? (
						// @ts-ignores
						<StyledControllerTextContainer isShortClips={props.isShortClips}>
							{/* @ts-ignores */}
							<StyledControllerText>
								{/* @ts-ignores */}
								<StyledText>{props?.ribbonTitle}</StyledText>
							</StyledControllerText>
						</StyledControllerTextContainer>
					) : (
						<></>
					)}
				</StyledController>
			</ControllerContainer>
		</View>
	);
};

export default Controller;
